import { makeStyles } from '@material-ui/core/styles';

import { draftModalActionButton } from '../policy-drafting.styles';

export default makeStyles((theme) => ({
  dialog: {
    width: 1280
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    gap: theme.spacing(6)
  },
  policyId: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    flexShrink: 0
  },
  subtitle: {
    color: theme.colorPalette.green_80,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(8)
  },
  headerCell: {
    fontWeight: 600,
    lineHeight: 1.5
  },
  bodyCell: {
    color: theme.colorPalette.green_90,
    fontWeight: 400,
    lineHeight: 1.5
  },
  table: {
    backgroundColor: theme.colorPalette.white,
    marginBottom: 0,
    '& th, & td': {
      paddingLeft: theme.spacing(6),
      paddingRight: theme.spacing(6)
    },
    '& thead th, & tbody td': {
      borderBottom: `1px solid ${theme.colorPalette.beige_50}`
    }
  },
  row: {
    height: 48,
    cursor: 'pointer',
    '& > td': {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2)
    },
    '&:hover': {
      backgroundColor: theme.colorPalette.orange_50_op_10
    },
    '&:hover $openDraft': {
      visibility: 'visible'
    }
  },
  openDraft: {
    visibility: 'hidden',
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: theme.colorPalette.orange_50,
    fontSize: 12,
    fontWeight: 600,
    lineHeight: 1.33
  },
  note: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2)
  },
  noteText: {
    color: theme.colorPalette.green_100,
    lineHeight: 1.43
  },
  actionButton: draftModalActionButton(theme),
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2),
    marginTop: theme.spacing(8)
  }
}));
